import script from "./GridDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./GridDetail.vue?vue&type=script&setup=true&lang=js"

import "./GridDetail.vue?vue&type=style&index=0&id=871225b0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-871225b0"]])

export default __exports__